import { useAuthState } from '../../services/auth';
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';

//import useBreadcrumbs from "use-react-router-breadcrumbs";
import { useNavigate } from 'react-router-dom';
import { Table, Pagination, Collapse, Row, Col, Modal, Button, Form, Navbar, Container, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const appNames = ['dde', 'mongo', 'mqtt', 'redis'];
//const appNames = ['DDE'];

export const Trustedips = () => {
  //const user: User = useUserState();
  const { token } = useAuthState();
  const [currentPage, setCurrentPage] = useState(1);
  const [dnsQueries, setDnsQueries] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<any>(1);
  const [pageSize, setPageSize] = useState<any>(1);
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const [showCreateForm, setShowCreateForm] = useState(false);

  const handleShowCreateForm = () => {
    setShowCreateForm(true);
  };

  const handleCloseCreateForm = () => {
    setShowCreateForm(false);
  };

  useEffect(() => {
    if (token) {
      fetchDnsQueries();
    }
  }, [token, currentPage]);

  async function fetchDnsQueries() {
    const data = await axios.get('/op/dns/trusted-domains?page=' + currentPage + '&pageSize=10');
    setTotalCount(data.data.totalCount);
    setPageSize(data.data.pageSize);
    setDnsQueries(data.data.items);
    console.log('aqui', data.data.items);
  }

  const totalPages = Math.ceil(totalCount / pageSize);
  const startIndex = (currentPage - 1) * pageSize;

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  const getPageItems = () => {
    const pageItems = [];
    const maxPageItems = 5;
    const maxPageItemsDelta = Math.floor(maxPageItems / 2);
    const startPage = Math.max(currentPage - maxPageItemsDelta, 1);
    const endPage = Math.min(currentPage + maxPageItemsDelta, totalPages);

    if (startPage > 1) {
      pageItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let pageNumber = startPage; pageNumber <= endPage; pageNumber++) {
      const isCurrentPage = pageNumber === currentPage;
      pageItems.push(
        <Pagination.Item key={pageNumber} active={isCurrentPage} onClick={() => handlePageChange(pageNumber)}>
          {pageNumber}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      pageItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    return pageItems;
  };

  const handleShowDeleteModal = (index: any) => {
    setSelectedItem(dnsQueries[index]);
    setSelectedIndex(index);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setSelectedItem(null);
    setSelectedIndex(-1);
    setShowDeleteModal(false);
  };

  const handleDeleteConfirm = async () => {
    try {
      await axios.delete(`/op/dns/trusted-domains/${dnsQueries[selectedIndex].id}`);
      handleCloseDeleteModal();
      fetchDnsQueries();
    } catch (err) {
      console.log(err);
    }
  };

  const handleCreateSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await axios.post(`/op/dns/trusted-domains`, {
        domain: e.target.domain.value,
        ip: e.target.ip.value,
      });
      handleCloseCreateForm();
      fetchDnsQueries();
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      {!showCreateForm && (
        <div className="text-right">
          <Button variant="success" size="sm" onClick={handleShowCreateForm}>
            Create
          </Button>
        </div>
      )}

      {showCreateForm && (
        <>
          <Form id="createForm" onSubmit={handleCreateSubmit}>
            <Form.Control type="text" name="domain" placeholder="Domain" required />

            <Form.Control className="mt-1" type="text" name="ip" placeholder="Ip" required />
          </Form>
          <Button form="createForm" variant="primary" size="sm" type="submit">
            Create
          </Button>{' '}
          <Button variant="secondary" size="sm" onClick={handleCloseCreateForm}>
            Cancel
          </Button>
        </>
      )}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Domain</th>
            <th>Ip</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {dnsQueries.map((item, index) => (
            <tr key={index}>
              <td>{item.domain}</td>

              <td>{item.ip}</td>
              <td>
                <Button variant="danger" onClick={() => handleShowDeleteModal(index)}>
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
        {getPageItems()}
        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>

      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete "{selectedItem?.description}"?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
